<template>
  <div class="l-content-inner">
    <IdFind v-if="currentStep === 1" @next="onIdFindNext" />
    <IdFindComplete v-if="currentStep === 2" :user-info="searchedUserInfo" />
  </div>
</template>
<script setup>
import IdFind from "@/components/paintpro/member/idFind.vue";
import IdFindComplete from "@/components/paintpro/member/idFindComplete.vue";
import { onMounted, ref } from "vue";
const currentStep = ref(1); // 1: find / 2: complete
const searchedUserInfo = ref(null);

onMounted(() => {});

const onIdFindNext = (userInfo) => {
  searchedUserInfo.value = userInfo;
  currentStep.value = 2;
};
</script>
